/* eslint-disable max-len */

import React from 'react';
import { useObserver } from '../../../CodesThatsGottaGoSomewhereElse';
import { DropButton } from '../../../ui/DropButton';
import { useResolve } from '../../Container';
import { ProfileModel } from '../../ProfileModel';
import { Avatar } from '../../common/Avatar';
import { Copy, Flexer } from '../../dashboard/elements/LayoutElements';
import { PopupManager } from '../../popups/PopupManager';
import { preferencesPopup } from '../../profile/PreferencesPopup';

const UserInfo = () => {
    const me = useObserver(useResolve(ProfileModel));
    return <Flexer flex="row" gap=".75" align="center" maxWidth="100%">
        <Avatar.ForUser size="2"
            user={me}
            variant="round"
        />
        <Copy flush size="1.125" truncate style={{ fontWeight: 450 }}>
            {me.name}
        </Copy>
    </Flexer>;
};

export const UserBlock = () => {

    const popups = useResolve(PopupManager);
    const onClick = () => {
        popups.invoke(preferencesPopup());
    };

    return <DropButton rounding=".5" overflow="0 .25" onClick={onClick}>
        <Flexer padding=".25 1" width="100%">
            <UserInfo />
        </Flexer>
    </DropButton>;
};
